module.exports = __webpack_public_path__ + "img/gun-turret-gun-shadow-2.37cb842c.png";